import React from 'react';
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TitlePage from '../TitlePage';


const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        margin: "100px auto",
        [theme.breakpoints.down('md')]: {
            width: '90%',
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            margin: "50px auto"
        }
    },
    item1: {
        width: "60%",
        [theme.breakpoints.down('md')]: {
            width: "70%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%"
        }
    },
    content: {
        lineHeight: "35px",
        paddingTop: 25,
        textAlign: "justify",
        color: "black",
        fontSize: "1rem"
    },
    item2: {
        width: "40%",
        position: "relative",

        [theme.breakpoints.down('md')]: {
            width: "70%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%"
        },
        "& img": {
            float: "right",
            width: "80%",
            position: "absolute",
            borderRadius: 3,
            // top: 60,
            top: 0,
            right: 0,
            [theme.breakpoints.down(1300)]: {
                width: "100%",
                marginTop: 50,
                position: "static",
            }
        }
    },
    svg: {
        width: 67,
        height: 66,
        position: "absolute",
        top: 33,
        left: "calc(20% - 33px)",
        fill: '#DA212E',
        [theme.breakpoints.down('md')]: {
            left: "calc(5% - 24px)",
            top: 40,
            width: 47,
            height: 46,
        }
    },

}))

export default function TextWithImg({ data }) {
    const classes = useStyles()

    return (

        <Box className={classes['root']}>
            <Box className={classes.item1}>
                <TitlePage position="bottomRight" padding="0px">
                    <p>{data.title}</p>
                </TitlePage>
                <p className={classes.content}>{data.content}</p>
            </Box>
            <Box className={classes.item2}>
                <img src={`/assets/images/${data.src}`} alt="trades-pouyan" />
                {/* <svg className={classes.svg}>
                        <use xlinkHref={`/sprit.svg#title-svg2`}></use>
                    </svg> */}
            </Box>
        </Box>

    )
}